import React from 'react';
import PropTypes from 'prop-types';
import { BOT } from '../../../../../../../api/bot/types';
import BotTextControl from './ctrl_text';
import BotButtonsControl from './ctrl_buttons';
import BotInputsControl from './ctrl_inputs';
import BotRadiobuttonInputsControl from './ctrl_radiobutton_inputs';
import BotRadiobuttonsControl from './ctrl_radiobuttons';
import Logger from '../../../../../../../../common/logger';
import * as WidgetActions from '../../../../../../layers/widget/actions';
import IPC from '../../../../../../../helpers/ipc';
import { MAIN_ACTIONS } from '../../../../../../main/types';
import './style.scss';

class BotMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: true,
            selectedCheckbox: '',
            selectedInputValue: '',
            isInputValid: false
        };
        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        if (e.target.tagName === 'A' && e.target.href === 'https://www.orange.pl/zaloguj.phtml') {
            e.preventDefault();
            WidgetActions.onClose('BOT', true, 'Redirect to login page');
            IPC.sendEvent(MAIN_ACTIONS.OPEN_URL, { url: e.target.href, self: true });
        } else {
            this.props.onClick(e);
        }
    }

    onSubmit(type, value) {
        Logger.log(`[BotMessage] onSubmit: type=${type}, value=${JSON.stringify(value)}`);

        this.props.onSend([{ type: type, value: value }]);

        this.setState({
            isActive: false
        });
    }

    render() {
        this.messages = [];

        this.props.message.split('&').forEach(m => {
            const item = JSON.parse(m.replace('%26', '&'));

            // group button controls into one div
            const last = this.messages[this.messages.length-1] || null;
            if(last && last.type === item.type && item.type === BOT.MESSAGE_TYPE.CONTROLS.BUTTONS) {
                for(let i = 0; i < item.value.length; i++) {
                    last.value.push(item.value[i]);
                }
            }
            else {
                this.messages.push(item);
            }
        });

        const renderControl = (message, i) => {
            switch (message.type) {
                case BOT.MESSAGE_TYPE.CONTROLS.TEXT:
                    return <BotTextControl key={i} text={message.value} />;
                case BOT.MESSAGE_TYPE.CONTROLS.BUTTONS:
                    return (
                        <BotButtonsControl
                            key={i}
                            buttons={message.value}
                            enabled={this.state.isActive && this.props.active}
                            onSubmit={data => this.onSubmit(message.type, data)}
                        />
                    );
                case BOT.MESSAGE_TYPE.CONTROLS.INPUTS:
                    return (
                        <BotInputsControl
                            key={i}
                            inputs={message.value}
                            enabled={this.state.isActive && this.props.active}
                            onSubmit={data => this.onSubmit(message.type, data)}
                        />
                    );
                case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTON_INPUTS:
                    return (
                        <BotRadiobuttonInputsControl
                            key={i}
                            inputs={message.value}
                            enabled={this.state.isActive && this.props.active}
                            onSubmit={data => this.onSubmit(message.type, data)}
                        />
                    );
                case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTONS:
                    return (
                        <BotRadiobuttonsControl
                            key={i}
                            inputs={message.value}
                            enabled={this.state.isActive && this.props.active}
                            onSubmit={data => this.onSubmit(message.type, data)}
                        />
                    );
                default:
                    return null;
            }
        };

        return (
            <div className="message-container bot-message" onClick={this.onClick}>
                {this.messages.map(renderControl)}
            </div>
        );
    }
}

BotMessage.defaultProps = {
    active: false,
    message: ''
};

BotMessage.propTypes = {
    active: PropTypes.bool,
    message: PropTypes.string.isRequired
};

export default BotMessage;
